import { TextField, TextFieldProps, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";

type Props = TextFieldProps & {
  maxChars?: number;
};

const DEFAULT_MAX_CHARS = 255;

export default function CharsLimitedTextField({
  maxChars: _maxChars,
  ...props
}: Props) {
  const [value, setValue] = useState(props.value as string | undefined);
  const maxChars = _maxChars || DEFAULT_MAX_CHARS;
  const charsLeft = maxChars - (value || "").length;

  useEffect(() => {
    setValue(props.value as string | undefined);
  }, [props.value]);

  return (
    <Stack sx={{ width: "100%" }}>
      <TextField
        {...props}
        onChange={(e) => {
          e.currentTarget.value = e.currentTarget.value.slice(0, maxChars);
          const { value } = e.currentTarget;
          setValue(value);
          props?.onChange && props.onChange(e);
        }}
        onBlur={(e) => {
          const { value } = e.currentTarget;
          setValue(value.trim());
          props?.onBlur && props.onBlur(e);
        }}
        value={value}
      />
      <Box
        sx={{ display: "flex", direction: "row", justifyContent: "flex-end" }}
      >
        <Typography color={charsLeft < 0 ? "error" : undefined}>
          Characters left: {charsLeft}
        </Typography>
      </Box>
    </Stack>
  );
}
